import { Api } from 'utils';

class ConsultationPlanService {

	static get = async (params?: any) => Api.createResponse('client/consultation-plans',params);
	static savePlan = async (params?: any) => Api.createResponse('client/consultation-plans/save-plan',params);
	
	static admin = {
		get: async (params?: any) => Api.createResponse('admin/consultation-plans',params),
		save: async (params?: any) => Api.createResponse('admin/consultation-plans/save',params),
		saveUser: async (params?: any) => Api.createResponse('admin/consultation-plans/save-user',params),
		delete: async (params?: any) => Api.createResponse('admin/consultation-plans/delete',params),
		getPlanList: async (params?: any) => Api.createResponse('admin/consultation-plans/plan-list',params),
		deletePlanUser: async (params?: any) => Api.createResponse('admin/consultation-plans/delete-plan-user',params),
	}

}

export default ConsultationPlanService;